import React, { useMemo } from "react";

import ToggleSwitch from "../ToggleSwitch";
import useDebounceCallback from "../../../../hooks/useDebounceCallback";
import {
  IAnswersByClass,
  OnePagePortfolioAssessmentAnswersByClass,
} from "../../../../state";

import styles from "./SwitchBox.module.scss";

export type Props = {
  label: string;
  answersByClass: IAnswersByClass | OnePagePortfolioAssessmentAnswersByClass;
  type: "answer_opened" | "name_opened";
  onChange: (id: number, check: boolean) => void;
};

const SwitchBox: React.FC<Props> = ({
  label,
  answersByClass,
  type,
  onChange,
}) => {
  const checked = useMemo(() => !!answersByClass[type], [answersByClass, type]);

  const [debounced] = useDebounceCallback((check: boolean) => {
    onChange(answersByClass.id, check);
  });

  const id = `${type}-${answersByClass.id}`;

  return (
    <div className={styles.switchBox}>
      <label
        className={styles.label}
        htmlFor={id}
        onClick={() => debounced(!checked)}
        style={{ cursor: "pointer" }}
      >
        {label}
      </label>
      <ToggleSwitch
        id={id}
        checked={checked}
        onChange={next => debounced(next)}
        aria-label={label}
      />
    </div>
  );
};

export default SwitchBox;
